import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../../../../../../util/getCustomColor";

export const GeneralWrapper = styled("div")(() => ({
  padding: "1rem 0 2rem 0",
}));

export const HeaderActions = styled("section")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
}));

export const TaskItemContainer = styled("div")(({ isOpen }: { isOpen?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  background: isOpen ? colors.gray50 : colors.white,
  borderTop: `1px solid ${colors.gray200}`,
  borderBottom: `1px solid ${colors.gray200}`,
  borderLeft: isOpen ? `1px solid ${colors.gray200}` : "",
  borderRight: isOpen ? `1px solid ${colors.gray200}` : "",
  borderRadius: isOpen ? "8px" : "",
  cursor: isOpen ? "default" : "pointer",
  margin: isOpen ? "20px 0px" : "",
}));

export const ButtonsContainer = styled("div")(() => ({
  display: "flex",
  padding: "16px 24px",
  justifyContent: "flex-end",
  alignItems: "center",
  borderTop: `1px solid ${colors.gray200}`,
}));

export const TaskItemHeader = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "16px 8px 16px 16px",
}));

export const MilestoneButtonContent = styled("div")(({ isEnabled }: { isEnabled?: boolean }) => ({
  display: "flex",
  width: "36px",
  height: "36px",
  justifyContent: "center",
  alignItems: "center",
  background: isEnabled ? getBrandCustom("primaryColor", colors.brandBlue500) : colors.gray100,
  border: `1px solid ${getBrandCustom("primaryColor", colors.brandBlue500)}`,
  borderRadius: "8px",
}));

export const TitleAndStatusContainer = styled("section")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: "16px",
}));

export const TaskTitle = styled("span")(() => ({
  color: colors.gray600,
  font: "700 18px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const OpenInfoSection = styled("div")(() => ({
  padding: "8px 16px 16px",
}));

export const TaskStatusMenuItem = styled("div")(({ selected }: { selected?: boolean }) => ({
  display: "flex",
  padding: "8px 12px",
  alignItems: "center",
  color: colors.gray600,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  background: selected ? "rgba(0, 85, 164, 0.12)" : colors.white,

  "&:hover": {
    cursor: "pointer",
    backgroundColor: "#ddd",
  },
}));

export const TaskStatusMenuTitle = styled("div")(() => ({
  display: "flex",
  padding: "4px 12px",
  alignItems: "center",
  color: colors.gray400,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const MultiDayTaskBadge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  backgroundColor: colors.brandBlue50,
  borderRadius: "100px",
  color: colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  padding: "8px 12px",
}));

const styles = makeStyles(() => ({
  defaultIconButton: {
    padding: 0,
    "&:not(:last-child)": {
      padding: "8px",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  selectedIconButton: {
    backgroundColor: "rgba(102, 112, 133, 0.12)",
    borderRadius: "8px",
  },
  milestoneButton: {
    padding: 0,
  },
  loadingSISTRS: {
    color: "#475467",
  },
  addTaskGrid: {
    marginBottom: "13px",
  },
  expandIcon: {
    fontSize: 24,
    cursor: "pointer",
    padding: "8px",
    marginLeft: "8px",
  },
  editDisabledLabel: {
    color: colors.gray600,
    font: "600 16px Manrope",
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
  menu: {
    "& .MuiPaper-root": {
      backgroundColor: colors.white,
    },
    "& .MuiList-padding": {
      padding: "0px",
    },
  },
  menuContainer: {
    width: 200,
    padding: "12px 0px",
    borderRadius: 12,
    boxShadow: "0px 2px 6px 2px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
  },
  badge: {
    height: "32px",
    padding: "6px 10px",
    "& > span": {
      font: "600 10px Manrope",
    },
  },
  iconMainContact: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    margin: "12px 8px 8px 8px",
  },
}));

export default styles;
